const AnnouncementBar=()=> null;export default AnnouncementBar;